<template functional>
  <div>
    <div>{{ props.item.notified_date }}</div>
    <div class="text-2xs">{{ props.item.notified_time }}</div>
  </div>
</template>

<script>
export default {
  name: "drayage-notified-at",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
